import * as squint_core from 'squint-cljs/core.js';
import * as dom from './cljdoc.client.dom.jsx';
import * as cljdoc_DOT_client_DOT_dom from './cljdoc.client.dom.jsx';
import * as page from './cljdoc.client.page.jsx';
import * as cljdoc_DOT_client_DOT_page from './cljdoc.client.page.jsx';
import * as str from 'squint-cljs/src/squint/string.js';
import * as clojure_DOT_string from 'squint-cljs/src/squint/string.js';
var toggle_meta_dialog = function () {
if (squint_core.truth_(dom.query(".js--main-scroll-view"))) {
const meta_icon_1 = dom.query("[data-id='cljdoc-js--meta-icon']");
const meta_dialog_2 = dom.query("[data-id='cljdoc-js--meta-dialog']");
const meta_close_3 = dom.query("[data-id='cljdoc-js--meta-close']");
const display_4 = "db-ns";
const hide_5 = "dn";
if (squint_core.truth_(str.starts_with_QMARK_(navigator.platform, "Mac"))) {
for (let G__6 of squint_core.iterable(dom.query_all("[data-id='cljdoc-js--modifier-key']", meta_dialog_2))) {
const el_7 = G__6;
el_7.innerText = "⌘"
}};
if (squint_core.truth_(meta_icon_1)) {
meta_icon_1.addEventListener("click", (function () {
dom.replace_class(meta_icon_1, display_4, hide_5);
if (squint_core.truth_(meta_dialog_2)) {
return dom.replace_class(meta_dialog_2, hide_5, display_4);
};

}))};
if (squint_core.truth_(meta_close_3)) {
return meta_close_3.addEventListener("click", (function () {
dom.replace_class(meta_dialog_2, display_4, hide_5);
if (squint_core.truth_(meta_icon_1)) {
return dom.replace_class(meta_icon_1, hide_5, display_4);
};

}));
};
};

};
var toggle_articles_tip = function () {
const tip_toggler_1 = dom.query("[data-id='cljdoc-js--articles-tip-toggler']");
const tip_2 = dom.query("[data-id='cljdoc-js--articles-tip']");
if (squint_core.truth_(((squint_core.truth_(tip_toggler_1)) ? (tip_2) : (tip_toggler_1)))) {
return tip_toggler_1.addEventListener("click", (function () {
return dom.toggle_class(tip_2, "dn");

}));
};

};
var add_next_prev_key_for_articles = function () {
const prev_link_1 = dom.query("a[data-id='cljdoc-prev-article-page-link']");
const next_link_2 = dom.query("a[data-id='cljdoc-next-article-page-link']");
if (squint_core.truth_(((squint_core.truth_(prev_link_1)) ? (prev_link_1) : (next_link_2)))) {
return document.addEventListener("keydown", (function (e) {
const code_3 = e.code;
if (squint_core.truth_(((("ArrowLeft" === code_3)) && (prev_link_1)))) {
document.location.href = prev_link_1.href};
if (squint_core.truth_(((("ArrowRight" === code_3)) && (next_link_2)))) {
return document.location.href = next_link_2.href;
};

}));
};

};
var init = function () {
if (squint_core.truth_(page.is_project_doc())) {
toggle_meta_dialog();
toggle_articles_tip();
return add_next_prev_key_for_articles();
};

};

export { init }
